import clsx from "clsx";
import InputLabel from "components/InputLabel";
import React from "react";

interface TextAreaProps extends React.HTMLProps<HTMLTextAreaElement> {
  labelName?: string;
  containerClass?: string;
  handleChange?: (value: string) => void;
  outerRef?: React.RefObject<HTMLTextAreaElement>;
  handleOnBlur?: (value: string) => void;
  hasError?: boolean;
}

const TextArea = ({
  containerClass,
  labelName,
  cols,
  rows,
  outerRef,
  ...props
}: TextAreaProps) => {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  React.useEffect(() => {
    const el = outerRef ? outerRef?.current : textareaRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    }
  }, [props.value]);

  return (
    <div className={clsx("grid w-full mx-auto", containerClass)}>
      {labelName && (
        <InputLabel
          required={props.required}
          labelName={labelName}
          name={props.name as string}
        />
      )}
      <textarea
        ref={outerRef ?? textareaRef}
        className={clsx(
          "focus:outline-none focus:ring-0 overflow-hidden min-h-9",
          "rounded-md border-gray-300 lg:text-sm !border-1 mb-0",
          "placeholder:text-gray-500 placeholder:text-sm placeholder:font-normal",
          props.className,
          {
            "!shadow-[inset_0_0_0_1px] !shadow-red-600 placeholder:text-red-500 ring-red-500":
              props.hasError,
          }
        )}
        rows={1}
        value={props.value || ""}
        placeholder={props.placeholder}
        onChange={(c) => props.handleChange?.(c.target.value)}
        onBlur={(value) => props.handleOnBlur?.(value.target.value)}
      />
    </div>
  );
};

export default TextArea;
